import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=6469a57e&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6469a57e')) {
      api.createRecord('6469a57e', component.options)
    } else {
      api.reload('6469a57e', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=6469a57e&", function () {
      api.rerender('6469a57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/email-info/compent/editor.vue"
export default component.exports